<template>
  <div class="wall p-20">
    <div class="wall-head">待发货订单</div>
    <el-table :data="tableData" style="width: 100%" v-loading="loading">
      <el-table-column prop="order_id" label="订单号" width="180"></el-table-column>
      <el-table-column prop="total_count" label="数量" width="180"></el-table-column>
      <el-table-column prop="total_amount" label="金额"></el-table-column>
      <el-table-column prop="cuser.username" label="用户"></el-table-column>
      <el-table-column prop="order_id" label="操作">
        <template slot-scope="scope">
          <router-link
            :to="{ path: '/order/item', query: { order_id: scope.row.order_id } }"
            class="color-primary"
          >
            详情
          </router-link>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getOrderList } from '@/api/order.js'
export default {
  data() {
    return {
      timer: null,
      loading: false,
      tableData: []
    }
  },
  created() {
    if (this.$store.getters.hasPermission('view_orders')) {
      this.loadOrderList()
    }
  },
  methods: {
    async loadOrderList(data = {}) {
      this.loading = true
      let params = Object.assign({
        limit: 10,
        offset: 0,
        status: 'unsend'
        }, data)
      let { results } = await getOrderList(params)
      this.tableData = results
      this.loading = false
    }
  }
}
</script>